import { useMutation } from "@tanstack/react-query";
import { apiClient } from "../../api/client";
import { PRIVACY_POLICY_VERSION } from "./ConsentCheckbox";

/**
 * TASK-19 · Privacy data-subject hooks (Ley 1581).
 * Endpoints exposed by the backend `privacy` app under /api/v1/privacy/.
 */

function useExportMyData() {
  return useMutation({
    mutationFn: () =>
      apiClient.get("/api/v1/privacy/export/").then((r) => r.data),
  });
}

function useDeleteMyAccount() {
  return useMutation({
    mutationFn: (reason = "") =>
      apiClient
        .delete("/api/v1/privacy/account/", { data: { reason } })
        .then((r) => r.data),
  });
}

function useRecordConsent() {
  return useMutation({
    mutationFn: (policyVersion = PRIVACY_POLICY_VERSION) =>
      apiClient
        .post("/api/v1/privacy/consent/", {
          policy_version: policyVersion,
          consent_given: true,
        })
        .then((r) => r.data),
  });
}

export { useExportMyData, useDeleteMyAccount, useRecordConsent };
